import * as React from "react";
import { PaymentItem, PaymentCategory } from "../../../../store/payments/paymentitems/PaymentItemEntities";
import { BaseList } from '../../../base/baseList';
import GoToTop from "../../../base/gototop";


export interface PaymentItemsListProps {
    list: Array<PaymentItem>;
    side: PaymentCategory;
}

export interface PaymentItemsListCallbacks {
    onRowClick?: (id: string, side: PaymentCategory) => void;
}

export class PaymentItemsList extends React.Component<PaymentItemsListProps & PaymentItemsListCallbacks>{

    constructor(props) {
        super(props);
    }

    private onRowClick(item: PaymentItem) {

        this.props.onRowClick(item.id, this.props.side);
    }

    private getRows(list: Array<PaymentItem>): JSX.Element[] {

        let elements = list.map(element => {
            
            let baseStyle = { cursor: "pointer" };

            if (element.isCustom) {
                return (
                    <tr key={element.id} style={baseStyle} onClick={() => this.onRowClick(element)}>
                        <td>
                            {element.description}
                        </td>
                    </tr>
                )
            } else {
                return (
                    <tr key={element.id}>
                        <td>
                            {element.description}
                        </td>
                    </tr>
                )
            }
        });

        return elements;

    }

    private getHead(): JSX.Element {

        return (
            <thead>
                <tr className="text-eurorounders">
                    <th>Descrizione</th>
                </tr>
            </thead>
        );

    }

    render() {

        return (
            <React.Fragment>
                <BaseList hasNextPage={false} list={this.props.list} active={false} onEndOfList={() => { }} getElements={(items: Array<PaymentItem>) => { return this.getRows(items) }} getHead={this.getHead} />
                <GoToTop />
            </React.Fragment>
        )
    }
}